
export const headerConfig = () => ({
  headers: {
    Authorization: "Bearer " + localStorage.getItem("userToken"),
    token: localStorage.getItem("userToken"),
  },
});
